import {React} from "../../components/eevi_react_exports";
import {EeviCoreModel, EeviCoreAccess} from "../eevi_core_data";

export interface EeviCoreContextData {
    model?: EeviCoreModel;
    access?: EeviCoreAccess;
}
export const EeviCoreContext = React.createContext<EeviCoreContextData>({});